export const BEDSIDE_SHIFT_REPORT = "Bedside Shift Report";
export const BEDSIDE_SHIFT_REPORT_URL = "/bedside-shift-report";
export const BEDSIDE_SHIFT_REPORT_SETTINGS_URL = "/settings/bedside-shift-report";
export const BEDSIDE_SHIFT_REPORT_URL_PATH = "bedside-shift-report";
export const BEDSIDE_SHIFT_REPORT_SETTINGS_URL_PATH = "settings/bedside-shift-report"
export const BEDSIDE_SHIFT_REPORT_PRINT_URL_PATH = `${BEDSIDE_SHIFT_REPORT_URL_PATH}/print`;